import { render, staticRenderFns } from "./cWait.vue?vue&type=template&id=0bea31a0&scoped=true&"
import script from "./cWait.vue?vue&type=script&lang=js&"
export * from "./cWait.vue?vue&type=script&lang=js&"
import style0 from "./cWait.vue?vue&type=style&index=0&id=0bea31a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea31a0",
  null
  
)

export default component.exports